import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import HomePage from './pages/HomePage';
import PlayPage from './pages/PlayPage';
import DashboardPage from './pages/DashboardPage';
import PuzzlePage from './pages/PuzzlePage';
import AnalysisPage from './pages/AnalysisPage';
import OpeningsPage from './pages/OpeningsPage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import LearnPage from './pages/LearnPage';
import ContactPage from './pages/ContactPage';
import VerifyPage from './pages/VerifyPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AdminPage from './pages/AdminPage';

import { SettingsProvider } from './context/SettingsContext';
import { SocketProvider } from './context/SocketContext';
import Layout from './components/Layout';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { user, loading, isGuest } = useAuth();
    if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>Cargando...</div>;
    if (!user && !isGuest) return <Navigate to="/login" />;
    return <>{children}</>;
};

const AdminProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>Cargando...</div>;
    if (user?.role !== 'ADMIN') return <Navigate to="/dashboard" />;
    return <>{children}</>;
};


const App: React.FC = () => {
    return (
        <Router>
            <AuthProvider>
                <SocketProvider>
                    <SettingsProvider>
                        <Routes>
                            <Route path="/login" element={<LoginPage />} />
                            <Route path="/register" element={<RegisterPage />} />
                            <Route path="/verify" element={<VerifyPage />} />
                            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                            <Route path="/reset-password" element={<ResetPasswordPage />} />
                            <Route path="/" element={<Layout><HomePage /></Layout>} />
                            <Route path="/play" element={<ProtectedRoute><Layout><PlayPage /></Layout></ProtectedRoute>} />
                            <Route path="/dashboard" element={<ProtectedRoute><Layout><DashboardPage /></Layout></ProtectedRoute>} />
                            <Route path="/puzzles" element={<ProtectedRoute><Layout><PuzzlePage /></Layout></ProtectedRoute>} />
                            <Route path="/analysis" element={<ProtectedRoute><Layout><AnalysisPage /></Layout></ProtectedRoute>} />
                            <Route path="/openings" element={<ProtectedRoute><Layout><OpeningsPage /></Layout></ProtectedRoute>} />
                            <Route path="/profile" element={<ProtectedRoute><Layout><ProfilePage /></Layout></ProtectedRoute>} />
                            <Route path="/settings" element={<ProtectedRoute><Layout><SettingsPage /></Layout></ProtectedRoute>} />
                            <Route path="/learn" element={<ProtectedRoute><Layout><LearnPage /></Layout></ProtectedRoute>} />
                            <Route path="/contact" element={<ProtectedRoute><Layout><ContactPage /></Layout></ProtectedRoute>} />
                            <Route path="/admin" element={<AdminProtectedRoute><Layout><AdminPage /></Layout></AdminProtectedRoute>} />
                        </Routes>
                    </SettingsProvider>
                </SocketProvider>
            </AuthProvider>
        </Router>
    );
};

export default App;
